var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiAnimated3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 47,
    viewBox: "0 0 101 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9613 34.1179H67.6313L73.6479 12.3716H77.9779L71.9613 34.1179ZM69.7124 13.0527C69.4165 12.6381 68.953 12.4308 68.3217 12.4308H44.5315L43.3577 16.6952H64.9978L63.7353 21.2458H46.4252V21.236H42.0952L38.505 34.2166H42.835L45.2416 25.5102H64.7019C65.3134 25.5102 65.8855 25.3029 66.4181 24.8883C66.9507 24.4737 67.3058 23.9604 67.4735 23.3484L69.8801 14.642C70.0675 13.9905 70.0083 13.4673 69.7124 13.0527ZM35.98 32.7557C35.7433 33.6145 34.9542 34.2166 34.0665 34.2166H11.7459C11.1344 34.2166 10.6807 34.0093 10.3848 33.5948C10.0889 33.1802 10.0199 32.6669 10.1974 32.0548L15.6419 12.4308H19.9719L15.1093 29.9621H32.4292L37.2918 12.4308H41.6218L35.98 32.7557Z",
    fill: "#70706E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4543 12.4111L90.9284 23.309L79.418 34.2068L85.4543 12.4111Z",
    fill: "#098041"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6077 12.4111L87.0818 23.309L75.5615 34.2068L81.6077 12.4111Z",
    fill: "#E97626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiAnimated3);
export default __webpack_public_path__ + "static/media/upiAnimated3.11435535c7540497403728fe6cace9bc.svg";
export { ForwardRef as ReactComponent };